import {createReducer} from '../../../utilities';
import {scope, REFRESH_STATS} from '../../../../actions/app/other/mpm/users';
import {
  REQUEST_STATS_MPM_USERS,
  SUCCESS_FETCH_STATS_MPM_USERS,
  FAIL_FETCH_STATS_MPM_USERS,
} from '../../../../actions/entities/statistics/mpmUsers';

const initialStatsMPMUsersStatisticsState = {
  ids: [],
  total: null,
  info: {
    isFetching: false,
    lastPayload: null,
    needRefresh: true,
    updatedAt: null,
  },
};

function requestMPMUsersStatistics(state, action) {
  return {
    ...state,
    info: {
      isFetching: true,
      lastPayload: action.payload,
      needRefresh: false,
      updatedAt: null,
    },
  };
}

function successFetchMPMUsersStatistics(state, action) {
  const {total, ids, payload, receivedAt} = action;
  return {
    ...state,
    ids,
    total,
    info: {
      isFetching: false,
      lastPayload: payload,
      needRefresh: false,
      updatedAt: receivedAt,
    },
  };
}

function failFetchMPMUsersStatistics(state, action) {
  const {errors, payload} = action;
  return {
    ...state,
    info: {
      ...state.info,
      isFetching: false,
      lastPayload: payload,
      needRefresh: false,
      errors,
    },
  };
}

function refreshMPMUsersStatistics(state) {
  return {
    ...state,
    info: {
      ...state.info,
      needRefresh: true,
    },
  };
}

export default createReducer(
  initialStatsMPMUsersStatisticsState,
  {
    [REQUEST_STATS_MPM_USERS]: requestMPMUsersStatistics,
    [SUCCESS_FETCH_STATS_MPM_USERS]: successFetchMPMUsersStatistics,
    [FAIL_FETCH_STATS_MPM_USERS]: failFetchMPMUsersStatistics,
    [REFRESH_STATS]: refreshMPMUsersStatistics,
  },
  scope,
);



// WEBPACK FOOTER //
// ./src/reducers/app/other/mpm/userStats.js